import { motion } from 'framer-motion';
import { EDUCATION, CERTIFICATIONS } from '../data/projects';

const Education = () => {
  return (
    <section id="education" className="section education">
      <div className="section__inner">
        <motion.p
          className="section__eyebrow"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Education &amp; Certifications
        </motion.p>
        <motion.h2
          className="section__title"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.08 }}
        >
          Learning that compounds
        </motion.h2>

        <div className="edu__grid">
          {EDUCATION.map((item, i) => (
            <motion.article
              key={item.id}
              className="edu__card"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.65, delay: i * 0.08 }}
            >
              <span className="edu__label">Education</span>
              <h3>{item.title}</h3>
              <p className="edu__place">{item.place}</p>
              <p className="edu__period">{item.period}</p>
            </motion.article>
          ))}

          {CERTIFICATIONS.map((item, i) => (
            <motion.article
              key={item.id}
              className="edu__card"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.65, delay: 0.12 + i * 0.08 }}
            >
              <span className="edu__label">Certification</span>
              <h3>{item.title}</h3>
              <p className="edu__place">{item.place}</p>
              <p className="edu__period">
                {item.period}
                {item.detail ? ` · ${item.detail}` : ''}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
